import axios from "axios";
import { requestError } from "../utils/RequestError";

export const getListOrder = async (params) => {
  try {
    const res = await axios.get(`/admin/orders`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getOrderById = async (id) => {
  try {
    const res = await axios.get(`/admin/orders/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const deleteOrder = async (id) => {
  try {
    const res = await axios.delete(`/admin/orders/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};
